<template>
    <div class="md-blog fashion" v-if="listing && listing.length > 0">
        <module-box
            class="blog-info"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            mobileNoMargin
        >
            <div class="mg-title">
                <div class="title" v-if="title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                <a
                    v-if="showMore"
                    class="mg-more"
                    :href="moreLinkByCategory"
                    :aria-label="'More blog articles'"
                    rel="noopener noreferrer"
                >{{ moreText }}</a>
            </div>
            <ul class="blog-list">
                <li
                    class="blog-card"
                    v-for="(items, index) in listing"
                    :key="items.url + index"
                >
                    <a
                        class="blog-jump"
                        :href="items.url"
                        :target="itemLinkTarget"
                        :aria-label="
                            $t('md-blog.blogDetailPageOf', {
                                title: items.title
                            })
                        "
                        rel="noopener noreferrer"
                    >
                        <img-box
                            class="blog-preview"
                            :src="items.previewPicture"
                            :alt="blogAlt(items)"
                        >
                            <div class="blog-text">
                                <div class="text-container">
                                    <h3 class="blog-title">
                                        {{ items.title }}
                                    </h3>
                                    <p class="blog-time">
                                        <only-client>
                                            {{ $ft.formatDate(+items.publishTime, 'MMMM dd, yyyy hh:mm p') }}
                                        </only-client>
                                    </p>
                                </div>
                            </div>
                        </img-box>
                        <div class="blog-footer">
                            <h3 class="mobile-title">{{ items.title }}</h3>
                            <p class="blog-description">
                                {{ items.previewContent }}
                            </p>
                            <span class="blog-more" aria-hidden="true">{{
                                $t('md-blog.more')
                            }}</span>
                        </div>
                    </a>
                </li>
            </ul>
            <p class="more-link">
                <a
                    v-if="showMore"
                    class="more"
                    :href="moreLink"
                    :aria-label="'More blog articles'"
                    rel="noopener noreferrer"
                >{{ moreText }}</a>
            </p>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
import OnlyClient from '@/components/global/only-client.vue';
export default {
    components: { OnlyClient },
    mixins: [common]
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-blog.fashion {
    .blog-info {
        position: relative;
        .mg-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title {
                position: relative;
                //  avoid occlusion  more article
                div {
                    @include ellipsis();
                }
            }

            .mg-more {
                flex-shrink: 0;
                display: inline-block;
                cursor: pointer;
                padding: 0 13px;
                line-height: 25px;
                height: 25px;
                font-size: 13px;
                color: #fff;
                letter-spacing: 0.6px;
                background: rgba(188, 188, 202, 0.8);
            }
        }

        .blog-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            margin-bottom: -20px;
            .blog-card {
                position: relative;
                margin-right: 20px;
                margin-bottom: 20px;
                display: flex;
                width: calc((100% - 40px) / 3);
                &:nth-child(3n) {
                    margin-right: 0;
                }

                .blog-jump {
                    display: block;
                    width: 100%;
                    height: 100%;
                    .blog-preview {
                        position: relative;
                        padding-top: 75%;
                        margin-bottom: 18px;
                        overflow: hidden;
                        &:hover {
                                box-shadow: 5px 10px 10px #aaa;
                            }
                        .blog-text {
                            position: absolute;
                            bottom: 0;
                            color: white;
                            height: 120px;
                            width: 100%;
                            padding: 0 20px;
                            opacity: 0.9;
                            background-image: linear-gradient(
                                to bottom,
                                rgba(8, 17, 38, 0) 2%,
                                rgba(8, 17, 38, 0.7) 100%
                            );
                            &:hover {
                                color:#4cff4f;
                            }
                            .text-container {
                                position: absolute;
                                bottom: 20px;
                                right: 20px;
                                left: 20px;

                                .blog-title {
                                    margin: 0;
                                    font-family: var(--font-bold);
                                    font-size: 20px;
                                    line-height: 22px;
                                    max-height: 44px;
                                    text-shadow: 0 1px 1px rgba(8, 17, 35, 0.3);
                                    @include webkitBox(2);
                                }
                                .blog-time {
                                    font-size: 14px;
                                    margin-top: 14px;
                                    font-family: var(--font-bold);
                                    line-height: 16px;
                                }
                            }
                        }
                    }
                    .blog-footer {
                        overflow: hidden;
                        position: relative;
                        .mobile-title {
                            display: none;
                        }
                        .blog-description {
                            margin-bottom: 52px;
                            line-height: 21px;
                            height: 63px;
                            color: #4a4a60;
                            @include webkitBox(3);
                            &:hover {
                                color:#4cff4f;
                            }
                        }
                        .blog-more {
                            display: inline-block;
                            width: 104px;
                            height: 32px;
                            line-height: 30px;
                            @include color-theme('border', 2px solid);
                            font-size: 13px;
                            @include color-theme();
                            text-align: center;
                            letter-spacing: 2px;
                            position: absolute;
                            bottom: 0;
                            &:hover {
                                color: #fff;
                                background-color:var(--color-theme, #03c9ff);
                            }
                        }
                    }
                }
            }
        }
        .more-link {
            display: none;
        }
    }
    @media (max-width: 999px) {
        .blog-info {
            .blog-list {
                .blog-card {
                    width: calc((100% - 20px) / 2);
                    margin-right: 20px;
                    &:nth-child(2n) {
                        margin-right: 0;
                    }
                    &:nth-child(3n) {
                        margin-right: 20px;
                    }
                }
            }
        }
    }
    @include media-600 {
        .blog-info {
            padding-bottom: 40px;
            .mg-title {
                position: static;
            }
            .title {
                text-align: center;
                .mg-more {
                    display: none;
                }
            }
            .blog-list {
                margin-bottom: 0;
                .blog-card {
                    width: 100%;
                    margin: 0;
                    display: flex;
                    padding: 0;
                    &:nth-child(2n) {
                        margin-right: 0;
                    }
                    &:nth-child(3n) {
                        margin-right: 0;
                    }
                    .blog-jump {
                        .blog-preview {
                            margin-bottom: 0;
                            height: 250px;
                            padding-top: 0;

                            .blog-text {
                                display: none;
                            }
                        }
                        .blog-footer {
                            padding: 20px 15px 94px;
                            background-color: #242a3d;
                            color: #fff;
                            .mobile-title {
                                display: block;
                                color: #fff;
                                font-size: 16px;
                                line-height: 16px;
                                margin-top: 0;
                                margin-bottom: 14px;
                                @include ellipsis;
                            }
                            .blog-description {
                                color: #fff;
                                margin-bottom: 0;
                                height: auto;
                            }
                            .blog-more {
                                position: absolute;
                                bottom: 20px;
                                left: 15px;
                                border-color: #fff;
                                color: #fff;
                            }
                        }
                    }
                }
            }
            .more-link {
                padding: 20px 0;
                display: block;
                text-align: center;
                .more {
                    display: inline-block;
                    color: #fff;
                    font-size: 13px;
                    padding: 1.5px 13px;
                    line-height: 22px;
                    background-color: #bcbcca;
                }
            }
        }
    }
}
</style>
